import axios from "axios";
import BaseApi from "../BaseApi";
import { TransitionCompleteResponse } from "src/Types/Task";
import { QuestionDialogJsonResponseType } from "src/Types/ReDoc";

export type CreateAndSendResponseType = TransitionCompleteResponse | QuestionDialogJsonResponseType;

export default class RdcSoapApi extends BaseApi {

	static startTask = async ( fileId: string, componentId: string, taskId: string ): Promise<TransitionCompleteResponse> => {
		const url = window.host + "/RdcSoapModule/StartTask";
		const data = { fileId, componentId, taskId };
		try {
			const request = await axios.post( url, data, { withCredentials: true });
			if ( this.checkUnauthorized( request ) ) {
				throw new Error("Ошибка при получении данных задачи" );
			}
			else {
				return request.data;
			}
		}
		catch (error: any) {
			throw new Error("Ошибка при получении данных задачи" );
		}
	};

	static cancelTask = async ( fileId: string, componentId: string, taskId: string ): Promise<TransitionCompleteResponse> => {
		const url = window.host + "/RdcSoapModule/CancelTask";
		const data = { fileId, componentId, taskId };
		try {
			const request = await axios.post( url, data, { withCredentials: true });
			if ( this.checkUnauthorized( request ) ) {
				throw new Error("Ошибка при получении данных задачи" );
			}
			else {
				return request.data;
			}
		}
		catch (error: any) {
			throw new Error("Ошибка при получении данных задачи" );
		}
	};

	/** Обработка события нажатия кнопки "Сформировать и отправить" */
	static createAndSendRequest = async ( fileId: string, componentId: string, choosenCheckbox: Array<string> ): Promise<CreateAndSendResponseType> => {
		const url = window.host + "/RdcSoapModule/CreateAndSendRequest";
		const data = { fileId, componentId, choosenCheckbox };
		try {
			const request = await axios.post( url, data, { withCredentials: true });
			if ( this.checkUnauthorized( request ) ) {
				throw new Error("Ошибка при формировании и отправки данных задачи" );
			}
			else {
				return request.data;
			}
		}
		catch (error: any) {
			throw new Error("Ошибка при формировании и отправки данных задачи" );
		}
	};

	/** Обработка события нажатия кнопки "Все равно отправить" */
	static justSendRequest = async ( fileId: string, componentId: string, choosenCheckbox: Array<string> ): Promise<TransitionCompleteResponse> => {
		const url = window.host + "/RdcSoapModule/JustSendRequest";
		const data = { fileId, componentId, choosenCheckbox };
		try {
			const request = await axios.post( url, data, { withCredentials: true });
			if ( this.checkUnauthorized( request ) ) {
				throw new Error("Ошибка при формировании и отправки данных задачи" );
			}
			else {
				return request.data;
			}
		}
		catch (error: any) {
			throw new Error("Ошибка при формировании и отправки данных задачи" );
		}
	};

};
